import { BuilderContentType } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/BuilderContentType';
// import { BuilderContentService } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderContentService';
export class SendMessageFromHttpActionSettings {
    constructor() {
        this.headers = {};
        this.$builderType = BuilderContentType.SelectImmediate;
        this.type = 'application/vnd.lime.select+json';
    }
}
